// import React from 'react';
// import './PopularCourses.css';

// const PopularCourses: React.FC = () => {
//   const courses = [
//     {
//       title: 'Blue Class',
//       age: '2-3 years',
//       description: 'Foundation for early learners with focus on sensory development and basic social skills.',
//       color: '#0900ff',
//       icon: '🎨'
//     },
//     {
//       title: 'Purple Class',
//       age: '3-4 years',
//       description: 'Building confidence through play-based learning and creative exploration activities.',
//       color: '#5b47ff',
//       icon: '🌱'
//     },
//     {
//       title: 'Yellow Class',
//       age: '4-5 years',
//       description: 'Preparing for school with advanced activities in reading, math, and problem-solving.',
//       color: '#ffd54f',
//       icon: '📚'
//     }
//   ];

//   return (
//     <section className="popular-courses" id="our_classes">
//       <div className="container">
//         <h2 className="section-title">Our Popular Courses</h2>
//         <p className="section-subtitle">Age-appropriate programs designed to foster development at every stage</p>
//         <div className="courses-grid">
//           {courses.map((course, index) => (
//             <div key={index} className="course-card" style={{ background: course.color }}>
//               <div className="course-icon">{course.icon}</div>
//               <h3>{course.title}</h3>
//               <div className="course-age">{course.age}</div>
//               <p>{course.description}</p>
//               <button className="course-btn">Learn More</button>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default PopularCourses;
// src/components/PopularCourses.tsx
import React from 'react';
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './PopularCourses.css';

const PopularCourses: React.FC = () => {
  const courses = [
    {
      id: 1,
      title: 'Play Group (PG)',
      age: '2-3 Years',
      description: 'Fun-filled learning through play, songs, and activities that develop motor skills and social interaction.',
      color: '#4f46e5',
      icon: '👶'
    },
    {
      id: 2,
      title: 'Nursery',
      age: '3-4 Years',
      description: 'Building foundational skills through interactive learning, storytelling, and creative activities.',
      color: '#7c3aed',
      icon: '🎨'
    },
    {
      id: 3,
      title: 'LKG',
      age: '4-5 Years',
      description: 'Introduction to basic concepts through play-way methods and hands-on learning experiences.',
      color: '#8b5cf6',
      icon: '✏️'
    },
    {
      id: 4,
      title: 'UKG',
      age: '5-6 Years',
      description: 'Preparing for formal schooling with structured learning and skill development.',
      color: '#a78bfa',
      icon: '📚'
    },
    {
      id: 5,
      title: 'Class 1',
      age: '6-7 Years',
      description: 'Building strong academic foundations with an emphasis on reading, writing, and arithmetic.',
      color: '#c4b5fd',
      icon: '🔢'
    },
    {
      id: 6,
      title: 'Class 2',
      age: '7-8 Years',
      description: 'Building on foundational skills with more advanced reading, writing, and math concepts.',
      color: '#e9d5ff',
      icon: '📝'
    },
    {
      id: 7,
      title: 'Class 3',
      age: '8-9 Years',
      description: 'Developing critical thinking and problem-solving skills across all subjects.',
      color: '#d8b4fe',
      icon: '🔍'
    },
    {
      id: 8,
      title: 'Class 4',
      age: '9-10 Years',
      description: 'Expanding knowledge with more complex concepts and independent learning.',
      color: '#c4b5fd',
      icon: '📖'
    },
    {
      id: 9,
      title: 'Class 5',
      age: '10-11 Years',
      description: 'Preparing for middle school with advanced curriculum and skill development.',
      color: '#a78bfa',
      icon: '🎓'
    }
  ];

  // Split courses into groups of 3 for carousel items
  const courseGroups = [];
  for (let i = 0; i < courses.length; i += 3) {
    courseGroups.push(courses.slice(i, i + 3));
  }

  return (
    <section className="popular-courses" id="courses">
      <div className="container">
        <div className="section-header text-center mb-5">
          <h2>Our Popular Courses</h2>
          <p className="text-muted">Discover our comprehensive learning programs for different age groups</p>
        </div>

        <Carousel 
          indicators={false} 
          controls={courseGroups.length > 1}
          interval={5000}
          className="courses-carousel"
        >
          {courseGroups.map((group, groupIndex) => (
            <Carousel.Item key={groupIndex} className="py-3">
              <div className="row g-4">
                {group.map((course) => (
                  <div key={course.id} className="col-md-4">
                    <div 
                      className="course-card h-100" 
                      style={{ background: course.color }}
                    >
                      <div className="course-icon">{course.icon}</div>
                      <h3>{course.title}</h3>
                      <div className="course-age">{course.age}</div>
                      <p>{course.description}</p>
                      <button className="course-btn">Learn More</button>
                    </div>
                  </div>
                ))}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default PopularCourses;